import { Component, OnInit, ViewChild } from '@angular/core';

import { Utils } from 'src/app/utils/utils';
import { AppComponent } from 'src/app/app.component';
import { DateUtils } from 'src/app/utils/date-utils';
import { environment } from 'src/environments/environment';
import { CustomForms } from 'src/app/components/forms/custom-forms';
import { MainComponent } from 'src/app/components/main/main.component';

import { MapComponent, MapLatLng, MapMarker } from 'movisat-maps';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';

import { SsoService } from 'src/app/services/sso/sso.service';
import { CerraduraService } from 'src/app/services/cerraduras/cerradura.service';

import { ElementoModel } from 'src/app/services/elements/models/elem.model';
import { CerraduraModel } from 'src/app/services/cerraduras/models/cerradura.model';
import { PosicionCerraduraModel } from 'src/app/services/cerraduras/models/posicionCerradura.model';

@Component({
  selector: 'app-listado-cerradura',
  templateUrl: './listado-cerradura.component.html',
  styleUrls: ['./listado-cerradura.component.css']
})
export class ListadoCerraduraComponent extends CustomForms implements OnInit {

  private componentRef = null;
  public theme = environment.tema;
  private subscriptionOnMarkerDragEnd; any = null;
  @ViewChild('form') form: jqxWindowComponent;
  @ViewChild('myGrid') grid: jqxGridComponent;
  //  Esto es para que los textos en los controles del grid salgan en español
  public langGrid = JqWidgets.getLocalization('es');
  public dataSource: any;
  public dataAdapter: any;
  public cerraduras: CerraduraModel[] = [];
  elemento: ElementoModel = new ElementoModel();
  private map: MapComponent;
  elementos: ElementoModel[] = [];
  checkSelect: number[] = [];
  private empresaId: number = this.ssoService.getTicket().Empresa.IdGestion;



  constructor(private cerraduraService: CerraduraService, private ssoService: SsoService) {
    super();
  }
  public columns = [

    {
      text: AppComponent.translate('Ns_movisat'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nsMovisat', width: 150,
      aggregates: [{
        'Total': function (aggregatedValue, currentValue: number) {
          return aggregatedValue + 1;
        }
      }], //agrego el total al grid
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates["Total"] !== undefined) {
          renderstring = '<div style="text-align: left;">' + AppComponent.translate('Total') + ': ' +
            aggregates["Total"] + '</div>';
        }
        return renderstring;
      }
    },
    { text: AppComponent.translate('Ns_fabricante'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nsFabricante' },
    { text: AppComponent.translate('Elemento'), columntype: 'textbox', filtertype: 'textbox', datafield: 'elemento' },
    { text: AppComponent.translate('Sim'), columntype: 'textbox', hidden: true, filtertype: 'textbox', datafield: 'sim', },
    { text: AppComponent.translate('Operador_telefonia'), columntype: 'textbox', hidden: true, filtertype: 'textbox', datafield: 'operadorTelefonia', cellsrenderer: this.renderText },
    { text: AppComponent.translate('Observaciones'), columntype: 'textbox', filtertype: 'textbox', datafield: 'observaciones', },
  ];

  renderRow(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (value) {
      let date = new Date(value);
      return '<div style="margin-left: 3px;">' + DateUtils.formatDate(date, true) + '</div>';
    }
  }

  renderText(row: number, columnfield: string, value: any,
    defaulthtml: string, columnproperties: any, rowdata: any): string {
    if (value) {

      // devuelve el operador de telefonia
      switch (value) {
        case 1:
          return '<div style="margin-left: 3px;"> Movistar </div>';
        case 2:
          return '<div style="margin-left: 3px;"> Vodafone </div>';
        case 3:
          return '<div style="margin-left: 3px;"> Orange </div>';
      }
    }
  }




  /**Inicializa el componente
*/
  init(componentRef: any) {
    this.componentRef = componentRef;
  }

  ngOnInit(): void {
    this.map = MainComponent.getInstance().getMap();
    this.getCerraraduras();
  }

  ngAfterViewInit(): void {
    this.addCustomForm(this.form);
    this.form.setTitle(AppComponent.translate('Cerradura'));
    Utils.renderSizeGrid(this.grid);
    this.onSubribeMap();
  }

  // obtiene las cerraduras
  async getCerraraduras() {
    this.cerraduras = await this.cerraduraService.getCerraduras();
    if (this.cerraduras) {
      this.dataSource = {
        dataType: 'json',
        dataFields: [
          { name: 'id', type: 'number', map: 'id' },
          { name: 'elemento', type: 'number', map: 'elemento>nombre' },
          { name: 'nsMovisat', type: 'string', map: 'nsMovisat' },
          { name: 'nsFabricante', type: 'string', map: 'nsFabricante' },
          { name: 'fechaCreacion', type: 'date', map: 'fechaCreacion' },
          { name: 'fechaModificacion', type: 'date', map: 'fechaModificacion' },
          { name: 'imei', type: 'string', map: 'imei' },
          { name: 'tagUhf', type: 'string', map: 'tag' },
          { name: 'sim', type: 'string', map: 'sim' },
          { name: 'operadorTelefonia', type: 'string', map: 'operadorTelefonia' },
          { name: 'observaciones', type: 'string', map: 'observaciones' },
        ],
        localdata: this.cerraduras
      }
      this.dataAdapter = new jqx.dataAdapter(this.dataSource);
    }

    const t = setTimeout(() => {
      clearTimeout(t);
      this.grid.autoresizecolumns();
    }, 500);
  }


  onRowClick(event) {
    this.elementos = MainComponent.getInstance().elementsList;
    this.elementos = this.elementos.filter(elemento => elemento.cerradura.id !== 0);
    let row: any = this.grid.getrowdatabyid(event.args.rowindex);
    this.elemento = this.elementos.find(e => e.Id == row.elementoId);
  }

  async onSelect(event: any) {
    // Si se seleccionan todos los elementos del grid
    switch (event.args.rowindex.length) {
      case 0:
        this.checkSelect = [];
        break;
      default:
        let rows: any[] = this.grid.getrows();
        let idRow: number[] = this.grid.getselectedrowindexes();
        this.checkSelect = [];
        rows.forEach((element, index) => {
          if (idRow.includes(index)) {
            this.checkSelect.push(element.id);
          }
        });
        this.checkSelect = this.onChangeArray(this.checkSelect);
        break;
    }
  }

  onUnSelect(event) {
    let row: any = this.grid.getrowdatabyid(event.args.rowindex);
    // elimino el elemento deseleccionado del array checkSelect
    this.checkSelect.splice(this.checkSelect.indexOf(row), 1);
  }


  onChangeArray(list: number[]): number[] {
    // Filtrar elementos repetidos y undefined
    list = list.filter((elem, index, self) =>
      index === self.findIndex((t) => t === elem) && elem !== undefined
    );
    return list;
  }


  onSubribeMap() {
    if (!this.subscriptionOnMarkerDragEnd) {
      this.subscriptionOnMarkerDragEnd = this.map.subscribeOnMarkerDragEnd(
        this,
        (_this: any, marker: MapMarker) => {
          if (
            MainComponent.getInstance().controlAmbitoActividad(
              marker.position
            )
          ) {
            this.elemento.Lat = marker.position.lat;
            this.elemento.Lng = marker.position.lng;
          } else {
            if (this.elemento.Lat && this.elemento.Lng) {
              MainComponent.getInstance().showError(
                'ATENCION',
                'Fuera_ambito',
                2000
              );
              marker.setPosition(
                new MapLatLng(this.elemento.Lat, this.elemento.Lng)
              );
            }
          }
        }
      );
    }
  }

  onPosicionar() {
    if (this.subscriptionOnMarkerDragEnd && this.elemento.Id !== 0) {
      this.map.setCenter(this.elemento.Marker.position);
      this.elemento.Marker.setZIndex(999);
      this.map.setZoom(18);
      this.form.collapsed(true);
      this.elemento.Marker.animate(2000);
    } else {
      MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
    }
  }

  // botones de acciones
  async onLocalizar() {
    let pedirPosicion: PosicionCerraduraModel = new PosicionCerraduraModel(this.checkSelect, this.empresaId);
    if (pedirPosicion && pedirPosicion.idsCerraduras.length !== 0) {
      let reult: any = await this.cerraduraService.pedirPosicion(pedirPosicion);
      if (reult.state == 'ok') {
        MainComponent.getInstance().showSuccess('ATENCION', 'Peticion_localizacion_realizada', 2000);
        this.grid.clearselection();
        this.checkSelect = [];
      }
    } else {
      MainComponent.getInstance().showError('ATENCION', 'Error_enviar_localizacion', 2000);
    }
  }

  onVer() {
    console.log('Ver');
  }
  onEliminar() {
    console.log('Eliminar');
  }


  onClose() {
    if (this.componentRef) {
      this.componentRef.destroy();

    }
    if (this.subscriptionOnMarkerDragEnd) {
      this.subscriptionOnMarkerDragEnd.unsubscribe();
      this.subscriptionOnMarkerDragEnd = null;
    }
  }

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }
}
